export const index_name = process.env.GATSBY_ALGOLIA_INDEX_NAME;

export const currency = process.env.GATSBY_CURRENCY;
export const country = "South Manchester";
export const defaultArea = process.env.GATSBY_DEFAULT_AREA ? process.env.GATSBY_DEFAULT_AREA : "London";
export const defaultArea_Slug = defaultArea.toLowerCase().replace(/ /g,'-');

export const defaultArea_Newhomes = process.env.GATSBY_DEFAULT_AREA_NEWHOMES ? process.env.GATSBY_DEFAULT_AREA_NEWHOMES : "London";
export const defaultArea_Newhomes_Slug = defaultArea_Newhomes.toLowerCase().replace(/ /g,'-');

export const site_name = process.env.GATSBY_SITE_NAME;
export const hasMyaccount = (process.env.GATSBY_MYACCOUNT || null) === '1' ? true : false;

export const epdqID = "epdq1487028";
export const shasign_pass = "e23dcdcb-b6e3-40fc-a95c-4050026ea0d8";

export const Default_View = "List"

export const IsAllAgentReview = true;
export const postCodeAddressAPI = "ncZgV7m79UipxWpivISlAw37900";

export const footerVatDetails = "Julian Wadden a subsidiary of Thornley Groves registered in England & Wales<br />Registered office address: 70 St. Mary Axe, London, EC3A 8BE<br />Registered company number: 05584761. VAT Number: 897231391<br />Part of Lomond";

export const Mail_Vars = {
    fb_link: "https://www.facebook.com/julianwaddenea/",
    tw_link: "https://twitter.com/julianwaddenea",
    company_phone: "0161 434 4311",
    available_time: "We're available from 9:30am- 5:30pm Monday to Thursday, Friday: 09.30am - 5.00pm, Saturday: 09.00am - 4.00pm and Sunday: Closed.",
    address: "764b Wilmslow Road, Didsbury, M20 2DR"
}

// export const PageLinks = {
//     about: "about-julianwadden",
//     general_enquiry: "general-enquiry",
//     news_insight: `about-julianwadden/insights`,
//     branch_finder: "about-julianwadden/branch-finder",
//     area_cover: "about-julianwadden/areas-we-cover",
//     branch_contact: "contact-us",
//     team_contact: "contact-us",
//     teams: "about-julianwadden/meet-the-team",
//     request_valuation: "property-valuation",
//     privacy_policy: "privacy-policy",
//     book_a_viewing: "book-a-viewing",
//     book_a_valuation: "property-valuation/home-visit-valuation",
//     send_to_friend: "send-to-friend",
//     property_to_rent: "property/to-rent",
//     property_for_sale: "property/for-sale",
//     reviews: "about-julianwadden/customer-reviews",
//     property_management: "landlords/property-management",
//     financial_services: `financial-services`
// }

export const PropertySearchURL = {
    residential: {
        sales:"/property/for-sale/",
        lettings:"/property/to-rent/",
        newhomes: "/new-homes/for-sale/"
    },
    commercial: {
        sales:"/commercial/for-sale/",
        lettings:"/commercial/to-rent/",
    },
    auction: {
        sales:"/auctions/for-sale/"
    }
}

export const PropertyDetailsURL = {
    residential: {
        sales:"/property-for-sale/",
        lettings:"/property-to-rent/",
        newhomes:"/new-homes-for-sale/"
    },
    commercial: {
        sales:"/commercial-for-sale/",
        lettings:"/commercial-to-rent/",
    },
    auction: {
        sales:"/auction-for-sale/"
    }
}

export const SearchTitle = {
    residential: {
        sales:"Properties for sale",
        lettings:"Properties to rent",
        newhomes:"New developments"
    },
    commercial: {
        sales:"Commercial properties for sale",
        lettings:"Commercial properties to rent",
    },
    auction: {
        sales:"Auction properties for sale"
    }
}

export const PopularSearch_Areas = [ 
    { value: "south-manchester", label: "South Manchester" },
    { value: "didsbury", label: "Didsbury" },
    { value: "marple", label: "Marple" },
    { value: "stockport", label: "Stockport" }   
]

export const PopularSearch_Types = [ 
    { value: "house", label: "Houses" },
    { value: "apartment", label: "Apartments" },
    { value: "bungalow", label: "Bungalows" },
    { value: "maisonette", label: "Maisonettes" }   
]

export const sortByList = [ 
    { value: "Newest", label: "Newest" },
    { value: "Oldest", label: "Oldest" },
    { value: "HighestPrice", label: "Highest Price" },
    { value: "LowestPrice", label: "Lowest Price" }   
]

export const SearchType = {
    sales:"Buy",
    lettings:"Rent",
    newhomes:"New homes"
}

export const FurnishedType = [    
    { value: 'furnished', label: 'Furnished' },
    { value: 'unfurnished', label: 'Unfurnished' },
    { value: 'part-furnished', label: 'Part furnished' },
]

export const leadooPageSlot = {
    sell_property:"Sellers",
    landlords:"Landlords",
    sales:"Sale listings",
    lettings:"",
    branch_finder:"",
    general_enquiry:"General enquiry",
    valuation:"Valuation",
    home:"Valuation"
}